import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

export const openaiHtml =             
'<div class="form-group text-left mt-2">' +
  '<label>' + lang.openai_html_label_reply_message + '</label><br/>' +
  
  '<div class="clearfix"></div><textarea class="form-control text_message"  name="text-text-message" id="text-text-message"></textarea>' +
'</div>' +

// Adds html for delay system
delayHtml
